import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DpadZoneType, MenuType, OfficeType, ROUTE_PATH } from '@core/constants';
import { LOGOUT } from '@core/constants/text.common';
import { Router } from '@angular/router';
import { LocalStorageService, SessionContextService, SessionStorageService, TvMenuRefreshService, TvStartupService } from '@core/services/common';
import { getCheckSheetType } from '@modules/check-sheet/helper/check-sheet-type.helper';
import { LOCAL_STORAGE_KEY, SESSION_STORAGE_KEY } from '@core/configs';
import { AuthService } from '@core/services/apis';
import { DpadControlService } from '@core/services/common/dpad-control.service';
import { MultipleSpinnerService } from '@core/services/common/multiple-spinner.service';
import { TvService } from '@core/services/common/tv.service';
import { Utils } from '@core/helper';
import { environment } from '@environments/environment';
import { Subscription } from 'rxjs';
declare var YT: any;
@Component({
  selector: 'caremoni-muti-screen',
  templateUrl: './muti-screen.component.html',
  styleUrl: './muti-screen.component.scss',
})

export class MutiScreenComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('videoEl') videoPlayer!: ElementRef<HTMLVideoElement>;
  @ViewChild('youtubeContainer') youtubeContainer!: ElementRef<HTMLVideoElement>;
  @Input() isScreens: boolean = true;
  @Input() dpadX: number = -1;
  @Input() dpadY: number = -1;
  @Output() logoutHandler = new EventEmitter<any>();
  environment = environment;
  DpadZoneType = DpadZoneType;
  youtubePlayer: any;
  MenuType = MenuType;
  LOGOUT = LOGOUT;
  brgHover = '#3a9dbd';
  menuTv: any = [];
  hoverTimerVideo: any = null;
  groupSkeletonItems = [0, 1, 2, 3, 4];
  private scrollSelectedGroupTimer: number | null = null;
  private readonly subscription = new Subscription();
  menuItemSelected: {
    type: MenuType,
    thumbnail: string,
    name: string,
    description: string,
    url: string
  } = {
    type: MenuType.SCREEN,
    thumbnail: '',
    name: '',
    description: '',
    url: '',
  }
  isShowMenuDialog: boolean = false;
  isLoaded: boolean = false;
  private readonly tvBlankBackHandler = () => this.openFocusedOrDefaultMenuItem();
  constructor(
    private router: Router,
    private sessionContextService: SessionContextService,
    private authService: AuthService,
    private dpadControlService: DpadControlService,
    private mutiLoadingService: MultipleSpinnerService,
    private tvService: TvService,
    private localStorageService: LocalStorageService,
    private tvMenuRefreshService: TvMenuRefreshService,
    private sessionStorageService: SessionStorageService,
    private tvStartupService: TvStartupService,
  ){}

  async ngOnInit() {
    await this.bindData();
    this.subscription.add(
      this.tvMenuRefreshService.reloadRequested$.subscribe(() => void this.reloadMenuAndReturnHome())
    );
    const remoteReloadScreen = this.sessionStorageService.getSessionData(SESSION_STORAGE_KEY.remoteReloadScreen);
    this.sessionStorageService.removeSessionData(SESSION_STORAGE_KEY.remoteReloadScreen);
    this.localStorageService.setItem(LOCAL_STORAGE_KEY.screen, 0);
    window.addEventListener('tv-blank-back', this.tvBlankBackHandler);
    window.addEventListener('tv-redirect', (event: any) => {
      this.isScreens = false;
      this.dpadControlService.subjectDpad(DpadZoneType.SCREEN);
      (window as any).AndroidBridge.onWebCloseTab();
      this.menuTv.forEach((menu: any, dY: number) => {
        menu.items.forEach(async (item: any, dX: number) => {
          if(item.id == event.detail.url){
            this.dpadControlService.setdXdY(dX, dY + 1);
            if(item.type == MenuType.SCREEN){
              this.dpadControlService.onSelectMenuDpad();
              this.router.navigateByUrl(this.getScreenPath(item.url));
            } else if(item.type == MenuType.VIDEO || item.type == MenuType.PDF || item.type == MenuType.IMG){
              this.dpadControlService.onSelectMenuDpad();
              this.tvService.setDataMenuTvShow(item);
              this.router.navigateByUrl('/' + ROUTE_PATH.TV_MENU_SHOW);
            } else if(item.type == MenuType.WEB){
              this.isScreens = true;
              (window as any).AndroidBridge.onWebNewTab(item.url);
            } else if(item.type == MenuType.RELOAD){
              await this.reloadMenuAndReturnHome();
            } 
            else return;
          }
        });
      });
    });

    this.resetSelectedFirstItem(false);
    
    setTimeout(() => {
      this.isLoaded = true;
      this.scheduleInitMenuFocus(remoteReloadScreen);
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    window.removeEventListener('tv-blank-back', this.tvBlankBackHandler);
  }

  async bindData(){
    this.menuTv = await this.tvService.getDataMenuTv();
    const officeSelected = this.sessionContextService.getOfficeSelected<any>();
    if(Utils.isNyusho(officeSelected.officeType)){
      let condition = (item: any) => item.showCase === -1 || item.showCase === 3;

      if(!officeSelected.isPremiumUser)
        condition = (item: any) => (item.showCase === -1 || item.showCase === 3) && item.reOrder !== true;

      this.menuTv = this.menuTv.map((menu: any) => ({
        ...menu,
        items: menu.items.filter(condition)
      }));
    } else {
      let condition = (item: any) => item.showCase === -1 || item.showCase === 2;

      if(!officeSelected.isPremiumUser)
        condition = (item: any) => (item.showCase === -1 || item.showCase === 2) && item.reOrder !== true;

      this.menuTv = this.menuTv.map((menu: any) => ({
        ...menu,
        items: menu.items.filter(condition)
      }));
    }
    this.menuTv = [...this.menuTv]
      .sort((a: any, b: any) => (Number(a.sortNo) || Number.MAX_SAFE_INTEGER) - (Number(b.sortNo) || Number.MAX_SAFE_INTEGER))
      .filter((menu: any) => menu.items?.length);

    if (!document.getElementById('youtube-iframe-api')) {
      const tag = document.createElement('script');
      tag.id = 'youtube-iframe-api';
      tag.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(tag);
    }
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["isScreens"] && changes['isScreens'].firstChange) {
      this.isScreens = true;
    } else if (changes && changes["isScreens"]) {
      this.isScreens = changes["isScreens"].currentValue; 
    }
    if((changes["dpadX"] && !changes['dpadX'].firstChange) || (changes["dpadY"] && !changes['dpadY'].firstChange)){
      if(this.dpadY != 0){
        const selectedItem = this.getMenuItemByDpad(this.dpadX, this.dpadY) ?? this.getFirstMenuItem();
        if(!selectedItem) return;
        this.setMenuItemSelected(selectedItem);
        if(this.youtubePlayer){
          this.youtubePlayer.destroy();
          this.youtubePlayer = null;
        }
        this.startHoverVideoTimer(this.menuItemSelected);
        this.scheduleScrollSelectedGroupToTop();
      }
    }
  }

  private getMenuItemByDpad(dpadX: number, dpadY: number) {
    if(dpadX < 0 || dpadY <= 0) return null;
    return this.menuTv?.[dpadY - 1]?.items?.[dpadX] ?? null;
  }

  private getFirstMenuItem() {
    return this.menuTv?.[0]?.items?.[0] ?? null;
  }

  startHoverVideoTimer(item: any) {
    if (!item) return;
    if (this.hoverTimerVideo) clearTimeout(this.hoverTimerVideo);
    const selected = { ...item }; // clone giữ lại menuItemSelected
    this.hoverTimerVideo = setTimeout(() => {
      switch (selected.type) {
        case MenuType.VIDEO:
          // let player = this.videoPlayer.nativeElement;
          // player.muted = true;
          // player.load();
          // player.play();
          break;

        case MenuType.YOUTUBE:
          selected.thumbnail = `https://img.youtube.com/vi/${selected.url}/hqdefault.jpg`;
          this.updateVideo(selected.url);
          break;

        default:
          break;
      }
    }, 500);
  }

  logout() {
    this.mutiLoadingService.show();
    this.authService.logout();
    this.mutiLoadingService.hide();
  }

  private setMenuItemSelected(item: any) {
    this.menuItemSelected = {
      type: item.type,
      thumbnail: item.thumbnail,
      name: item.name,
      description: item.description,
      url: item.url,
    }
  }

  private resetSelectedFirstItem(moveDpad: boolean = true) {
    const firstItem = this.getFirstMenuItem();
    if(!firstItem) return;
    this.setMenuItemSelected(firstItem);
    if(moveDpad) setTimeout(() => {
      this.scheduleInitMenuFocus();
    });
    else this.scheduleScrollSelectedGroupToTop();
  }

  private async reloadMenuAndReturnHome() {
    this.mutiLoadingService.show();
    await this.bindData();
    this.mutiLoadingService.hide();
    this.resetSelectedFirstItem();
    this.isScreens = true;
    await this.router.navigateByUrl('/' + ROUTE_PATH.TV_BLANK, { replaceUrl: true });
  }

  async changePage(item: any){
    if(this.isScreens) this.isScreens = !this.isScreens;
    if(item.type != MenuType.RELOAD) this.localStorageService.setItem(LOCAL_STORAGE_KEY.screen, item.id);
    try {
      (window as any).AndroidBridge.onWebCloseTab();
    } catch (error) { }
    if(item.type == MenuType.SCREEN){
      const screenPath = this.getScreenPath(item.url);
      if(this.isSameLogicalScreen(screenPath)) {
        // 
         this.dpadControlService.restoreScreenFocusFromTvLayout();
        return;
      }
      this.dpadControlService.onSelectMenuDpad();
      this.router.navigateByUrl(screenPath);
    }
    else if(item.type == MenuType.VIDEO || item.type == MenuType.PDF || item.type == MenuType.IMG){
      this.dpadControlService.onSelectMenuDpad();
      this.tvService.setDataMenuTvShow(item);
      this.router.navigate(['/' + ROUTE_PATH.TV_MENU_SHOW]);    
    }
    else if(item.type == MenuType.YOUTUBE){
      this.dpadControlService.onSelectMenuDpad();
      this.tvService.setDataMenuTvShow(item);
      this.router.navigate(['/' + ROUTE_PATH.TV_MENU_SHOW_YB]);    
    }
    else if(item.type == MenuType.WEB){
      this.isScreens = true;
      try {
        (window as any).AndroidBridge.onWebNewTab(item.url);
      } catch (error) { }
    }
    else if(item.type == MenuType.RELOAD){
      await this.reloadMenuAndReturnHome();
    }
    else return;
       
    // else if(projectType == MenuType.FILE){
    //   this.dpadControlService.onSelectMenuDpad();
    //   this.tvService.setData({ projectType: MenuType.FILE, fileLink: item.fileLink, fileThumbnail: item.imgSrc });
    //   this.router.navigate([item.routerLink]);    
    // }
  }

  private async openFocusedOrDefaultMenuItem() {
    if (!this.isLoaded || !this.menuTv?.length) return;

    const focusedItem = this.getMenuItemByDpad(this.dpadX, this.dpadY) ?? this.getFirstMenuItem();
    if (!focusedItem) return;

    const itemPosition = this.findMenuItemPosition(focusedItem);
    if (itemPosition) this.dpadControlService.setdXdY(itemPosition.dX, itemPosition.dY);
    await this.changePage(focusedItem);
  }

  private findMenuItemPosition(itemSelected: any) {
    for (let dY = 0; dY < this.menuTv.length; dY++) {
      const dX = this.menuTv[dY]?.items?.findIndex((item: any) => item === itemSelected || item.id === itemSelected.id);
      if (dX >= 0) return { dX, dY: dY + 1 };
    }
    return null;
  }

  private getScreenPath(url: string): string {
    return '/' + this.getScreenRoute(url);
  }

  private isSameLogicalScreen(targetPath: string): boolean {
    const target = this.getResolvedScreenPath('/' + this.getLogicalScreenRoute(targetPath));
    return this.getLogicalScreenRoute(this.router.url) === this.getLogicalScreenRoute(target);
  }

  private getLogicalScreenRoute(path: string): string {
    const route = (path ?? '').replace(/^\/+/, '').split('?')[0].replace(/\/+$/, '');

    return route;
  }

  private getScreenRoute(url: string): string {
    const route = (url ?? '').replace(/^\/+/, '');
    const checkSheetRoutes: { [key: string]: string } = {
      'tv/nyusho': ROUTE_PATH.TV_CHECK_SHEET_NYUSHO,
      'tv/tsusho': ROUTE_PATH.TV_CHECK_SHEET_TSUSHO,
      [ROUTE_PATH.TV_SHORT_TIME]: ROUTE_PATH.TV_CHECK_SHEET_SHORT_TIME,
      [ROUTE_PATH.TV_FUNCTIONAL_TRAINING]: ROUTE_PATH.TV_CHECK_SHEET_FUNCTIONAL_TRAINING,
    };

    return checkSheetRoutes[route] ?? route;
  }

  createPlayer(url: string = ''){
    this.youtubePlayer = new YT.Player(this.youtubeContainer.nativeElement, {
      width: '100%',
      height: '100%',
      videoId: url,
      playerVars:{ autoplay: 1, mute: 1, loop: 1, controls: 0, playlist: url },
      events:{ onReady: (event: any) => { event.target.playVideo(); }}
    });
  }

  updateVideo(url: string) {
    if(this.youtubePlayer) this.youtubePlayer.loadVideoById(url);
    else this.createPlayer(url);
  }

  onImgError(event: Event) {
    (event.target as HTMLImageElement).src = environment.avatarUrl + '/caremoni-tv-app/content/thumbnail_default.png';
  }

  getItemDisplayName(item: any): string {
    if (item.type === MenuType.SCREEN &&
        (item.url?.includes(ROUTE_PATH.TV_SHORT_TIME) || item.url?.includes(ROUTE_PATH.TV_FUNCTIONAL_TRAINING))) {
      const name = item.name ?? '';
      const parenIdx = name.search(/[（(]/);
      if (parenIdx > 0) {
        return name.substring(0, parenIdx) + '<br>' + name.substring(parenIdx);
      }
    }
    return item.name ?? '';
  }

  getVisibleMenuGroups(): Array<{ menu: any, index: number, dpadIndex: number }> {
    const selectedGroupIndex = this.dpadY > 0 ? this.dpadY - 1 : 0;
    return this.menuTv
      .map((menu: any, index: number) => ({ menu, index, dpadIndex: index + 1 }))
      .filter((group: any) => Math.abs(group.index - selectedGroupIndex) <= 1);
  }

  private scheduleScrollSelectedGroupToTop() {
    if (this.scrollSelectedGroupTimer) window.clearTimeout(this.scrollSelectedGroupTimer);

    this.scrollSelectedGroupTimer = window.setTimeout(() => {
      requestAnimationFrame(() => {
        this.scrollSelectedGroupToTop();

        window.setTimeout(() => this.scrollSelectedGroupToTop(), 120);
      });
    });
  }

  private scheduleInitMenuFocus(remoteReloadScreen: any = null) {
    setTimeout(() => {
      requestAnimationFrame(() => {
        this.dpadControlService.initFirstAccess();
        this.scheduleScrollSelectedGroupToTop();
        if (remoteReloadScreen) this.reopenRemoteReloadScreen(remoteReloadScreen);
      });
    });
  }

  // Reopen the screen shown before a remote Reload (saved by FirebaseDeviceSessionService, or by TvStartupService for
  // the first reload after updating from web older than 1.17.0). Same as the tv-redirect handler, but back to the saved
  // URL, so every screen comes back as it was (check sheet type, user detail, ...); screens needing more use reloadScreenHooks.
  private reopenRemoteReloadScreen(saved: { screen: any, path: string }) {
    // blank / menu-show are reopened by TvStartupService itself (menu-show data is only in memory); startup is not a screen.
    if (!saved.path?.startsWith('/tv/') || saved.path === '/' + ROUTE_PATH.TV_STARTUP
      || this.tvStartupService.isStartupProtectedRoute(saved.path)) return;
    const item = this.findReloadItem(saved);
    this.isScreens = false;
    this.dpadControlService.subjectDpad(DpadZoneType.SCREEN);
    if (item) {
      const itemPosition = this.findMenuItemPosition(item)!;
      this.dpadControlService.setdXdY(itemPosition.dX, itemPosition.dY);
      this.dpadControlService.onSelectMenuDpad();
    }
    // Same screen id as before the reload (sent to the Pocket app by CareMoni_App).
    this.localStorageService.setItem(LOCAL_STORAGE_KEY.screen, saved.screen);
    // Drop the DPAD_UP the app sends ~600ms after the page load (onPageFinished → onStep), meant for the menu.
    const loadEnd = (performance.getEntriesByType?.('navigation')?.[0] as PerformanceNavigationTiming | undefined)?.loadEventEnd || performance.now();
    this.dpadControlService.ignoreDpadUpUntil = loadEnd + 1000;
    this.reloadScreenHooks[saved.path]?.(item);
    this.router.navigateByUrl(saved.path);
  }

  // Screens that need more than reopening their URL after a reload, keyed by path (item: the focused menu item, if any).
  private readonly reloadScreenHooks: { [path: string]: (item: any) => void } = {
    // User detail (user kept in detailData): BACK returns to the screen it was opened from, as when opened from the list.
    ['/' + ROUTE_PATH.TV_USER_DASHBOARD_DETAIL]: (item) => {
      if (item) this.dpadControlService.setOnBackDPad(() => this.router.navigateByUrl(this.getScreenPath(item.url)));
    },
  };

  // Menu item to focus for the saved screen. Match by path: the URL is reliable, while the saved id is not (check sheets
  // store the fixed id 102, tv-redirect does not update it); the id picks among same-path items, or names the source
  // screen of a page without a menu item (user detail).
  private findReloadItem(saved: { screen: any, path: string }) {
    const screenItems = this.menuTv.flatMap((menu: any) => menu.items).filter((item: any) => item.type == MenuType.SCREEN);
    const pathItems = screenItems.filter((item: any) => this.getResolvedScreenPath(item.url) === saved.path);
    if (!pathItems.length) return screenItems.find((item: any) => item.id == saved.screen);
    return pathItems.find((item: any) => item.id == saved.screen) ?? pathItems[0];
  }

  // Path a menu URL ends on: /tv/check-sheet opens the office's check sheet type (see CheckSheetComponent).
  private getResolvedScreenPath(url: string): string {
    const path = this.getScreenPath(url);
    if (path !== '/' + ROUTE_PATH.TV_CHECK_SHEET) return path;
    const officeType = this.sessionContextService.getOfficeSelected<any>()?.officeType ?? OfficeType.newTsusho;
    return `${path}/${getCheckSheetType(officeType)}`;
  }

  private scrollSelectedGroupToTop() {
    const selectedDpadIndex = this.dpadY > 0 ? this.dpadY : 1;
    const heightScroll = document.getElementById('heightScroll');
    const groupEl = document.querySelector<HTMLElement>(`[data-tv-menu-group="${selectedDpadIndex}"]`);

    if (!heightScroll || !groupEl) return;

    const offsetTop = groupEl.getBoundingClientRect().top - heightScroll.getBoundingClientRect().top;
    if (Math.abs(offsetTop) < 1) return;

    heightScroll.scrollTo({
      top: heightScroll.scrollTop + offsetTop,
      left: heightScroll.scrollLeft,
      behavior: 'auto',
    });
  }

  getThumbnailUrl(item: any): string {
    return item?.thumbnail
      ? environment.avatarUrl + item.thumbnail
      : environment.avatarUrl + '/caremoni-tv-app/content/thumbnail_default.png';
  }

  trackByVisibleMenuGroup(index: number, group: { menu: any, index: number, dpadIndex: number }): number {
    return group.menu?.menuID ?? group.index;
  }

  trackByItemId(index: number, item: any): number {
    return item?.id ?? index;
  }

}

